import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=b4fe1b80&scoped=true"
import script from "./TreeView.vue?vue&type=script&lang=js"
export * from "./TreeView.vue?vue&type=script&lang=js"
import style0 from "./TreeView.vue?vue&type=style&index=0&id=b4fe1b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fe1b80",
  null
  
)

export default component.exports